import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=f5c10c0a"
import script from "./CustomerList.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports